const state = {
  all: ["Stripe", "PayChoice"],
  gateways: ["Stripe", "PayChoice"].filter(
    (gateway) => !process.env.VUE_APP_HIDDEN_PAYMENT_GATEWAYS.split(",").includes(gateway)
  ),
};

const getters = {
  isSingleGateway: (state) => () => state.gateways.length < 2,
  defaultGateway: (state) => () => state.gateways[0],
};

export default {
  namespaced: true,
  state,
  getters,
};
